'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { PhoneS } from '@lichtblick/photon/icons/technology/phone-s';
import { Modal } from '@lichtblick/photon/organisms/modal/modal';
import { useState } from 'react';
import styles from './hotline-modal.module.css';
import { HOTLINE_MODAL_TITLE } from './hotline-modal-content';
export const HotlineModal = ({ ctaVariant, children })=>{
    const [isOpen, setIsOpen] = useState(false);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            ctaVariant === 'text' ? /*#__PURE__*/ _jsx(BoxCTA, {
                as: "button",
                onClick: ()=>setIsOpen(true),
                wide: true,
                "data-dd-action-name": "hotline modal open click",
                children: "Zur Hotline"
            }) : /*#__PURE__*/ _jsx(BoxCTA, {
                as: "button",
                leftSlot: /*#__PURE__*/ _jsx(PhoneS, {}),
                onClick: ()=>setIsOpen(true),
                wide: true,
                "data-dd-action-name": "hotline modal open click",
                className: styles.cta,
                variant: "neutral-outline",
                ariaLabel: "Zur Hotline"
            }),
            /*#__PURE__*/ _jsx(Modal, {
                footerContent: /*#__PURE__*/ _jsx(TextCTA, {
                    as: "button",
                    onClick: ()=>setIsOpen(false),
                    children: "Schließen"
                }),
                isOpen: isOpen,
                onPointerDownOutside: ()=>setIsOpen(false),
                title: HOTLINE_MODAL_TITLE,
                children: children
            })
        ]
    });
};

//# sourceMappingURL=hotline-modal.js.map